(function () {
    'use strict';

    angular.module('components.dataPresentation', []);
})();